import { Button } from "@/components/atoms/index";
import Typography from "@mui/material/Typography";
import { useFilterJobs } from "@/providers/contexts/index";
import { JobSetting } from "@/types/jobPost";
import { useJobPostFilterOptions } from "@/hooks";

export const JobSettingFilter = ({ expanded = false }) => {
  const { filters: jobPostFilters, loading: jobPostFiltersLoading } =
    useJobPostFilterOptions();
  const { filters, dispatch, loading } = useFilterJobs();

  const { selectedJobSettings } = filters;
  const jobSettings = jobPostFilters?.jobSettings ?? [];

  const remoteJobSetting = jobSettings.find(
    jobSetting => jobSetting.id === 5, // Remote
  );

  const handleJobSettingToggle = (jobSetting: JobSetting) => {
    const isSelected = (selectedJobSettings ?? []).some(
      selected => selected.id === jobSetting.id,
    );

    const updatedSettings = isSelected
      ? selectedJobSettings.filter(selected => selected.id !== jobSetting.id)
      : [...selectedJobSettings, jobSetting];
    dispatch({
      type: "SET_FILTERS",
      payload: { selectedJobSettings: updatedSettings },
    });
  };

  return (
    <>
      <Typography variant="body1">Job Setting</Typography>

      {expanded
        ? jobSettings.map(jobSetting => (
            <Button
              componentName="job-setting-filter"
              key={jobSetting.id}
              variant={
                (selectedJobSettings ?? []).some(
                  selected => selected.id === jobSetting.id,
                )
                  ? "contained"
                  : "outlined"
              }
              fullWidth
              sx={{ my: 1 }}
              onClick={() => handleJobSettingToggle(jobSetting)}
              loading={loading || jobPostFiltersLoading}
            >
              {jobSetting.setting_name as JobSetting["setting_name"]}
            </Button>
          ))
        : remoteJobSetting && (
            <Button
              componentName="job-setting-filter"
              key={remoteJobSetting.id}
              variant={
                (selectedJobSettings ?? []).some(
                  selected => selected.id === remoteJobSetting.id,
                )
                  ? "contained"
                  : "outlined"
              }
              fullWidth
              sx={{ my: 1 }}
              onClick={() => handleJobSettingToggle(remoteJobSetting)}
              loading={loading || jobPostFiltersLoading}
            >
              {remoteJobSetting.setting_name as JobSetting["setting_name"]}
            </Button>
          )}
    </>
  );
};
